import React, { useState, useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Box, Grid, Popper } from '@mui/material';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';

import audioMuteBtnImg from '../media/2x/02_button/button_mute_2x-min.png';
import audioUnMuteBtnImg from '../media/2x/02_button/button_sound_2x-min.png';
import audioPauseBtnImg from '../media/2x/02_button/button_pause_2x-min.png';
import audioPlayBtnImg from '../media/2x/02_button/button_play_2x-min.png';

import audioVolumeBg from '../media/2x/04_audio/audio_0_2x-min.png';
import audioVolumePillLeft from '../media/2x/01_intro/intro_load_0_2x_pill-left.png';
import audioVolumePillRight from '../media/2x/01_intro/intro_load_0_2x_pill-right.png';
import audioVolumePillMiddle from '../media/2x/01_intro/intro_load_0_2x_pill.png';

import CustomIconButton from './CustomIconButton';

let pauseGameBackgoundMusic = (paused) => {
    var audio = document.getElementById('background-audio');
    if (!audio) {
        console.error("background-audio not found");
        return;
    }

    if (paused) {
        audio.pause();
    }
    else {
        audio.play();
    }
}

const CustomAudioPlayer = ({ audioUrl, autoplay, audioTranscript, viewId, paused }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [progress, setProgress] = useState(0);
    const audioRef = useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    //listen for change event on audioUrl
    React.useEffect(() => {
        if (audioUrl) {
            setProgress(0);
        }
    }, [audioUrl]);

    //listen for change on muted
    React.useEffect(() => {
        console.log("isMuted", isMuted);
    }, [isMuted]);

    React.useEffect(() => {
        if (paused) {
            audioRef.current.audio.current.pause();
        }else{
            setTimeout(() => {
                try {
                    audioRef.current.audio.current.play();  
                } catch (error) {
                    console.log("Error: ", error);
                }
                  
            }, 1000);
        }
    }, [paused]);
    
    const togglePlay = () => {
        let playing = !isPlaying;

        setIsPlaying(playing);
    };

    const toggleMute = () => {
        let ar = audioRef.current;
        let updateValue = !isMuted;
        
        ar.audio.current.muted = updateValue;
        setIsMuted(updateValue);

        pauseGameBackgoundMusic(updateValue);
    };

    const handleTimeUpdate = (e) => {
        setProgress((e.srcElement.currentTime/e.srcElement.duration) * 100);

        // Add an event listener to window for the custom event
        const event = new CustomEvent('autoTrackProgressEvent', {
            detail: { 
                audioUrl: audioUrl,
                viewId: viewId,
                currentTime: e.srcElement.currentTime,
                duration: e.srcElement.duration,
                progress: (e.srcElement.currentTime/e.srcElement.duration) * 100
            }, // Add event-specific data
        });
        window.dispatchEvent(event); // Dispatch the event

        //if window.gameBackgroundMusicPaused is true, pause the audio
        //if window.gameBackgroundMusicPaused is false, play the audio and set window.gameBackgroundMusicPaused undefined
        if(window.gameBackgroundMusicPaused){
            audioRef.current.audio.current.pause();
            //set a interval to check if the gameBackgroundMusicPaused is set to false
            setInterval(() => {
                if(window.gameBackgroundMusicPaused === false){
                    audioRef.current.audio.current.play();
                    window.gameBackgroundMusicPaused = undefined
                }
            }, 1000);
        }
    };

    const openCC = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }

    const popperOpen = Boolean(anchorEl);

    return (
        <div style={{marginTop:0}} class="audio-player">
            <div>
                <AudioPlayer
                    style={{ display: 'none' }}
                    ref={audioRef}
                    src={audioUrl?audioUrl:""}
                    autoPlay={autoplay !== undefined ? autoplay : false}
                    onPlay={()=>{
                        //pauseGameBackgoundMusic(!isPlaying);
                        togglePlay();
                        console.log("onPlay: ", isPlaying);
                        pauseGameBackgoundMusic(false);
                    }}
                    onPause={() => {
                        togglePlay();
                        console.log("onPause: ", isPlaying);
                        //pauseGameBackgoundMusic(true);
                    }}
                    onListen={handleTimeUpdate}
                    muted={isMuted}
                />
                <Grid container>
                    <Grid item>
                        <CustomIconButton onClick={audioRef?.current?.togglePlay} color="primary">
                            {/* {isPlaying ? <Pause /> : <PlayArrow />} */}
                            <img src={isPlaying ? audioPauseBtnImg : audioPlayBtnImg} alt="play/pause" style={{ width: 50, height: 50 }} />
                        </CustomIconButton>
                    </Grid>
                    <Grid item>
                        <CustomIconButton onClick={toggleMute} color="primary">
                            {/* {isMuted ? <VolumeOff /> : <VolumeUp />} */}
                            <img src={isMuted ? audioMuteBtnImg : audioUnMuteBtnImg} alt="play/pause" style={{ width: 50, height: 50 }} />
                        </CustomIconButton>
                    </Grid>
                    <Grid item>
                        <div style={{ marginTop: 19 }}>
                            <div style={{ position: 'relative' }}>
                                <img src={audioVolumeBg} alt="volume" style={{ width: 102, height: 26 }} />
                                {progress > 0 && (
                                    <img
                                        id="loader-pill-left"
                                        height={16}
                                        width={8}
                                        src={audioVolumePillLeft}
                                        alt="0%"
                                        style={{ position: 'absolute', top: 5, left: 6 }}
                                    />
                                )}
                                <div
                                    style={{
                                        overflow: 'hidden',
                                        position: 'absolute',
                                        top: 5, // Match the vertical alignment of left and right parts
                                        left: 14,
                                        width: Math.floor((progress / 100) * 76), // Dynamically calculate width
                                        height: 16, // Match the height of the pill images
                                    }}
                                >
                                    <img
                                        id="loader-pill"
                                        height={16}
                                        width={76}
                                        src={audioVolumePillMiddle}
                                        alt="0%"
                                        style={{
                                            display: 'block', // Ensures proper rendering within the container
                                        }}
                                    />
                                </div>
                                {progress > 0 && (
                                    <img
                                        id="loader-pill-right"
                                        height={16}
                                        width={8}
                                        src={audioVolumePillRight}
                                        alt="0%"
                                        style={{
                                            position: 'absolute',
                                            top: 5,
                                            left: Math.floor(14 + (progress / 100) * 76), // Correct position for right part
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </Grid>
                    <Grid item>
                        {audioTranscript && 
                        <>
                            <CustomIconButton aria-describedby="cc" onClick={openCC}>
                                <ClosedCaptionIcon />
                            </CustomIconButton>
                            <Popper id={viewId} open={popperOpen} anchorEl={anchorEl} style={{zIndex:1000}} >
                                <Box sx={{ border: 1, p: 2, bgcolor: 'background.paper', maxWidth: 550, borderRadius: 8, marginLeft:10}}>
                                    <p className='normal'>{audioTranscript}</p>
                                </Box>
                            </Popper>
                        </>
                        }
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default CustomAudioPlayer;
